export const CATEGORY_REPORT_ID = 'category';
